import { initZoomCallback } from '@/infrastructure/engine2d/input/zoomCallback';
import type { Canvas, TPointerEventInfo } from 'fabric';
import type { TViewportConstraints } from '@/utils/TViewportConstraints';

// Owns the wheel-zoom attach / detach on the canvas.
class ZoomController {
    private readonly _callback: (opt: TPointerEventInfo) => void;
    private readonly _canvas: Canvas;

    constructor(canvas: Canvas, notifyZoom: (zoom: number) => void, getConstraints: () => TViewportConstraints) {
        this._canvas = canvas;
        this._callback = initZoomCallback(canvas, notifyZoom, getConstraints);
        this._canvas.on('mouse:wheel', this._callback);
    }

    getCallback(): (opt: TPointerEventInfo) => void {
        return this._callback;
    }

    dispose(): void {
        this._canvas.off('mouse:wheel', this._callback);
    }
}

export { ZoomController };
